

















import { Component, Vue, Prop } from 'vue-property-decorator'
import { TranslateResult } from 'vue-i18n'
import { LocaleDict, LocaleKeys } from '../../lib/Locale'

@Component<AddDialog>({})
export default class AddDialog extends Vue {
  @Prop()
  title?: string | TranslateResult

  dialog = false

  @Prop()
  target!: LocaleDict

  get keys() {
    return LocaleKeys
  }

  save() {
    this.dialog = false
    this.$emit('save')
  }

  cancel() {
    this.dialog = false
    this.$emit('canceled')
  }
}
